import React from "react";
import classNames from "classnames";
import { ReactComponent as VariablesIcon } from "../../../assets/icons/variables.svg";
import Dropdown from "../../theme/dropdown/Dropdown";
import Button from "../../theme/button/Button";
import Badge from "../../theme/badge/Badge";
import Text from "../../theme/text/Text";
import Help from "../../help/Help";
import Styles from "./Variables.module.scss";
import { FormField } from "../../../__generated__/api";
import { ReplacementGroup } from "../../replacement-group";

interface VariablesToggleProps {
    onClick: (group: ReplacementGroup, row: FormField) => void;
    isShowing: boolean;
    setIsShowing: (isShowing: boolean) => void;
    replacements: ReplacementGroup[];
}

const HELP_ARTICLE_ID = "urn:fq:article:3b53681f4cf64fdaa552d9cec2ffba45";

export default function VariablesToggle({
    onClick, isShowing, setIsShowing, replacements,
}: VariablesToggleProps) {
    return (
        <Dropdown onToggle={nextValue => setIsShowing(nextValue)} show={isShowing}>
            <Dropdown.Toggle
                prefixIcon={<VariablesIcon />}
                size="small"
                className={classNames("toolbar-action", Styles.button, isShowing ? Styles["button-open"] : undefined)}
                variant="ghost-gray"
            />
            <Dropdown.Menu>
                <div className={Styles.replacements}>
                    <div className={Styles.header}>
                        <Text as="strong" textVariant="body-1-semibold">
                            Variables
                            {" "}
                            <Help buttonType="small-icon" articleId={HELP_ARTICLE_ID} />
                        </Text>
                        <Button isClose size="small" variant="none" onClick={() => setIsShowing(false)} />
                    </div>

                    {replacements?.map(group => (
                        <div className={Styles["replacement-group"]} key={group.id}>
                            <Text as="strong" textVariant="body-2-semibold">
                                {group.label}
                            </Text>
                            <Text as="p" textVariant="body-2-regular">
                                {group.description}
                            </Text>
                            <div className={Styles["replacement-list"]}>
                                {group.input?.map(row => (
                                    <Button
                                        key={row.id}
                                        type="button"
                                        variant="none"
                                        onClick={() => onClick(group, row)}
                                    >
                                        <Badge title={row.description as string} variant="info">
                                            {row.name}
                                        </Badge>
                                    </Button>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
}
